import React, { useCallback, useContext, useState } from "react";
import { TalkToUsContext } from "../../context/talkToUs";
import RequestDemoButton from "../RequestDemoButton";
import RequestDemoForm from "../RequestDemoForm";

import classes from "./RequestDemoWrapper.module.css";

const TalkToUs = () => {
  const { state, isOpen, open, close, onClose } = useContext(TalkToUsContext);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const handleSubmit = useCallback(() => {
    setIsFormSubmitted(true);
  }, []);

  return (
    <div>
      <RequestDemoButton onClick={open} isOpen={isOpen}></RequestDemoButton>
      <div
        className={[classes.container, isOpen ? "" : classes.closed].join(" ")}
      >
        <div className={classes.popoverHeader}>
          {isFormSubmitted ? <p>WE WILL BE IN TOUCH</p> : <p>REQUEST A DEMO</p>}
          <button
            className={classes.closeButton}
            onClick={() => {
              close();
              onClose();
            }}
          >
            <div className={classes.closeSymbol} />
          </button>
        </div>
        <div className={classes.popoverBody}>
          {state && <RequestDemoForm onSubmit={handleSubmit} />}
        </div>
      </div>
    </div>
  );
};

export default TalkToUs;
